import ApiService, { callCustomMethodAsync } from "../service/ApiService";

const moduleName = "dda_template";

const ContractTemplateConfigApi = {
  async list(query, loading) {
    let api = {
      module: moduleName,
      type: "list",
      value: query,
      dontLoading: loading === undefined ? false : loading,
    };
    return await ApiService(api);
  },

  async findById(id, loading) {
    let api = {
      module: moduleName,
      type: "findById",
      value: { id: id },
      dontLoading: loading === undefined ? false : loading,
    };
    return await ApiService(api);
  },

  async create(dataForm) {
    delete dataForm.id;
    let api = {
      module: moduleName,
      type: "create",
      value: dataForm,
      message: {
        success: "hidden",
        error: "hidden",
      },
    };
    const result = await ApiService(api);
    mushroom[moduleName].invalidCache();
    return result;
  },

  async update(dataForm) {
    const params = {};
    if (dataForm.id) {
      params.id = dataForm.id;
      delete dataForm.id;
    }
    let api = {
      module: moduleName,
      type: "partialUpdate",
      value: dataForm,
      params: params,
      message: {
        success: "hidden",
        error: "hidden",
      },
    };
    const result = await ApiService(api);
    mushroom[moduleName].invalidCache();
    return result;
  },

  async delete(id) {
    let api = {
      module: moduleName,
      type: "delete",
      value: { id: id },
      message: {
        success: "Xóa thành công!",
        error: "hidden",
      },
    };
    const result = await ApiService(api);
    mushroom[moduleName].invalidCache();
    return result;
  },

  async getParamValuesForContractTemplate(id) {
    let api = {
      module: moduleName,
      type: "views",
      viewAction: "GetParamValuesForContractTemplate",
      value: { id: id },
    };
    return await ApiService(api);
  },
};

export default ContractTemplateConfigApi;
